import { getHumanReadableFileSize } from '@emma-helpers/file.helper';

export const getFileSizeError = (size: number, minSize: number, maxSize: number): string => {
  let fileErrorText = $localize`El fichero no cumple los límites de tamaño`;
  const limits: string[] = [];
  if (minSize > 0) {
    limits.push($localize`mínimo ${getHumanReadableFileSize(minSize)}`);
  }
  if (maxSize < Infinity) {
    limits.push($localize`máximo ${getHumanReadableFileSize(maxSize)}`);
  }
  if (limits.length) {
    fileErrorText += `: ${limits.join(', ')}.`;
  } else {
    fileErrorText += `.`;
  }
  return fileErrorText;
};
